<style scoped>
@import url("../assets/css/exam.css");
</style>

<template>
    <div class="home-content common-home-content" v-show="show">
        <div id="anchor" class="ice_bg space_pl space_pr space_pb clearfix">  
            <h1 class="ce-exam-title">{{department_label}}测验</h1>
            <div class="examForm font-level4" id="frmExam">
                <input type="hidden" name="depid" :value="department_id">
                <input type="hidden" id="qno" :value="questions.length" />
                <dl class="ce-exam-question"
                  :class="show_index == index?'ce-question-current': ''"
                  v-for="(child, index) in questions"
                  :key="index"
                >
                    <dt>
                        <input type="hidden" name="qid" :value="child.id" />
                        <input type="hidden" name="aid" :value="child.id" />
                        <span>第{{index+1}}题：</span>{{child.question}}
                    </dt>
                    <dd class="ce-question-choice"
                      v-for="(answer, answer_index) in child.answers"
                      :key="answer_index"
                      @click="answerClick(index, answer_index)"
                    >
                        <span class="ce-question-options clearfix">
                            <div class="radio"
                              :class="answer_index == answer_arr[index]?'radio-selected':''"
                            >
                                <input class="none" :id="answer.id" type="radio" :name="child.id"  :value="answer.code"/>
                            </div>
                            {{child.index}}<span v-if="answer_index == 0">A.</span> 
                            <span v-else-if="answer_index == 1">B.</span> 
                            <span v-else-if="answer_index == 2">C.</span>
                            <span v-else-if="answer_index == 3">D.</span> 
                            <span v-else>E.</span>
                        </span>
                        <label :for="answer.id" class="ce-question-answer"><span v-html="answer.answer"></span></label>
                    </dd>
                </dl>
                <div class="ce-exam-submitbutton clearfix">
                    <div class="question_prev fl"
                      :class="show_index == 0?'prev_first':''"
                    >
                        <a @click="preClick()"><span href="#anchor" class="btn_1">上一题</span></a>
                    </div>
                    <div class="question_next fl"
                      :class="[show_index == 0?'ques_next':'', (show_index+1) == questions.length?'none_exam':'']"
                    >
                        <a @click="nextClick()"><span  href="#anchor" class="btn_1">下一题</span></a>
                    </div>
                    <div class="question_submit button-style-anthor fl"
                      :class="(show_index+1) == questions.length?'':'none_exam'"
                      @click="submitClick()"
                    >
                        <a><span class="btn_1">提交</span></a>
                    </div>
                </div> 
            </div>
        </div>
        <div class="submit-tips-window" @click.stop="consoleWindow(false)" v-show="window_show">
          <div class="window-content" @click.stop="consoleWindow(null)">
              <p class="window-content-text">提示</p>
              <p class="window-content-title">测验尚未完成，是否提交？</p>
              <div class="window-btns clearfix">
                  <button class="left fl" @click.stop="consoleWindow(true)">确定</button>
                  <button class="right fr" @click.stop="consoleWindow(false)">取消</button>
              </div>
          </div>            
      </div>
    </div>
</template>

<script>
import {_} from 'vue-underscore';
export default {
  data() {
    return {
      questions: [],
      show: false,
      department: {},
      department_label: '',
      department_pinyin: '',
      user_id: '',
      answer_arr: [],
      answer_obj: {},
      qid: [],
      department_id: 1,
      seed: '',
      show_index: 0,
      window_show: false
    };
  },
  created() {
    this.loadinti();
    window.appBack = ()=> this.pageback();
  },
  methods: {
    loadinti(){
        var that = this;
        that.seed = this.$utils.getUrlKey("s");
        that.department_label = that.$route.params.name;
        that.department_pinyin = that.$route.query.pinyin;
        this.$api.get("/ce/exam/"+that.department_label, {params: {"s": that.seed , 'pinyin': that.department_pinyin}}).then(function(res) {
            that.department_id = res.data.department.id;
            that.questions = res.data.questions;
            for(var i = 0; i < that.questions.length; i++){
              that.qid.push(that.questions[i].id.toString());
            }
            that.show = true;
        });
    },
    answerClick(index,index2){
      this.$set(this.answer_arr, index, index2)
    },
    preClick(){
      this.show_index -= 1;
    },
    nextClick(){
      this.show_index += 1;
    },
    submitFnuction(){
      let that = this;
      for(let i = 0; i < this.questions.length; i++){
        if(that.answer_arr[i] != undefined){
          that.answer_obj[that.questions[i]["id"]] = that.questions[i]["answers"][that.answer_arr[i]]["code"];
        }
      }
      
      that.answer_obj["depid"] = that.department_id;
      that.answer_obj["qid"] = that.qid;
      that.answer_obj["aid"] = that.qid;
      that.$api.post("/ce"+that.$route.fullPath, that.answer_obj).then(function(res) {
          that.window_show = false;
          res.data["s"] = that.seed;
          that.$router.push({name:'result',params: res.data});
      });
      
    },
    submitClick(){
      var that = this;
      if(_.without(that.answer_arr, undefined).length < that.questions.length){
          that.window_show = true;
      }else{
        that.submitFnuction();
      }
    },
    consoleWindow(bol){
        if(bol){
          this.submitFnuction();
        }else{
          this.window_show = false;
        }
    },
    pageback(){
        window.history.back();
        return true;
    }  
  }
}
</script>

